import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "adu-lab-uat.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "adu-lab-uat",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "adu-lab-uat.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "290043620197",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:290043620197:web:84993351cecd5f440f8f8c",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || undefined
};

// Validate configuration
if (import.meta.env.VITE_ENV === 'production' && !import.meta.env.VITE_FIREBASE_API_KEY) {
  console.error('Firebase configuration error: Environment variables not set');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const storage = getStorage(app);

const appCheckSiteKey = import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY;
let appCheck = null;
if (appCheckSiteKey && typeof window !== 'undefined') {
  const debugToken = import.meta.env.VITE_FIREBASE_APPCHECK_DEBUG_TOKEN;
  if (import.meta.env.DEV && debugToken) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  }

  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    console.warn('Firebase App Check initialization skipped:', error.message);
  }
}

// Analytics — only initialize when measurementId is configured (avoids 404 on config fetch)
let analytics = null;
if (firebaseConfig.measurementId) {
  isSupported().then((supported) => {
    if (supported) analytics = getAnalytics(app);
  }).catch(() => {});
}
export { analytics };
export { appCheck };

// For debugging - expose to window in development
// (window guard: node-based unit tests import this module with no DOM)
if (import.meta.env.DEV && typeof window !== 'undefined') {
  window.firebaseApp = app;
  window.firebaseAuth = auth;
  window.firebaseDb = db;
}

export { app };
export default app;
